import { Col, Row } from 'antd';

import { Button, ModalActionButtons } from 'components/ui';
import { STEPS } from 'horizon/routes/Inspections/InspectionDetail/InspectionDamageIngestion/ModalContent/common';
import {
  LabelText,
  ValueText,
} from 'horizon/routes/Inspections/InspectionDetail/InspectionDamageIngestion/ModalContent/common.style';
import {
  type DataField,
  type HeaderMappingEntry,
  type PreviewDamage,
} from 'horizon/routes/Inspections/InspectionDetail/InspectionDamageIngestion/types';

import { ConfirmationWarnings } from './ConfirmationWarnings';
import {
  COORDS_VALIDATION_WARNING_MSG,
  DATE_VALIDATION_WARNING_MSG,
  isValidCoordinates,
  isValidDateFormat,
} from './utils';

type LegacyConfirmationProps = {
  dataFields: DataField[];
  headerMapping: HeaderMappingEntry[];
  previewDamage: PreviewDamage;
  setStep: (step: number) => void;
  handleSubmit: () => void;
  isSubmitting?: boolean;
};

export const LegacyConfirmation = ({
  dataFields,
  previewDamage,
  headerMapping,
  setStep,
  handleSubmit,
  isSubmitting = false,
}: LegacyConfirmationProps) => {
  // Legacy release-toggle fallback. Remove this path when damage_csv_validation graduates.
  const previewValueFor = (schemaFieldId: string) => {
    const header = headerMapping.find(m => m.schemaFieldId === schemaFieldId)?.fileHeader;
    return header ? previewDamage[header] ?? '' : '';
  };
  const isDateField = (m: HeaderMappingEntry) =>
    m.schemaFieldId === 'DATE' ||
    m.schemaFieldId === 'INSPECTION_DATE' ||
    dataFields.find(f => f.key === m.schemaFieldId)?.label === 'Date';
  const isCoordsField = (m: HeaderMappingEntry) => m.schemaFieldId === 'COORDINATES';

  const isDateError = headerMapping.filter(isDateField).some(m => {
    const value = previewValueFor(m.schemaFieldId);
    return value !== '' && !isValidDateFormat(value);
  });
  const isCoordsError = headerMapping.filter(isCoordsField).some(m => {
    const value = previewValueFor(m.schemaFieldId);
    return value !== '' && !isValidCoordinates(value);
  });

  const warnings = [
    ...(isDateError ? [DATE_VALIDATION_WARNING_MSG] : []),
    ...(isCoordsError ? [COORDS_VALIDATION_WARNING_MSG] : []),
  ];

  return (
    <>
      <p>Preview of first created Damage</p>
      {headerMapping.map(({ fileHeader, schemaFieldId }) => (
        <Row key={schemaFieldId}>
          <Col flex="1" />
          <Col flex="auto">
            <LabelText>{dataFields?.find(({ key }) => key === schemaFieldId)?.label}:</LabelText>
          </Col>
          <Col flex="50%">
            <ValueText>{fileHeader ? previewDamage[fileHeader] : ''}</ValueText>
          </Col>
          <Col flex="50px" />
        </Row>
      ))}
      <ConfirmationWarnings warnings={warnings} />
      <ModalActionButtons>
        <Button
          onClick={() => {
            setStep(STEPS.mapping);
          }}
        >
          Back
        </Button>
        <Button
          type="primary"
          onClick={handleSubmit}
          disabled={isSubmitting}
          loading={isSubmitting}
        >
          {warnings.length > 0 ? 'Ignore warning, proceed with upload' : 'Create'}
        </Button>
      </ModalActionButtons>
    </>
  );
};
